import React from "react";
import "leaflet/dist/leaflet.css";
import "../../../css/Common/Components/DesignSystem/Map.css";
import "../../../css/App.css";
import ButtonGreen from "../DesignSystem/Buttons/ButtonGreen";
import ImageDirectory from "frontend/HelperFunctions/ImageDirectory";

/**
 * MapComponent displays a static map image with the address and working hours of the Rosemount Financial Solutions IFA office.
 * It also provides a button that opens Google Maps with directions to the office location.
 *
 * @component
 * @returns {JSX.Element} The rendered map, address, working hours, and a "Get Directions" button.
 *
 * @example
 * <MapComponent />
 *
 * @remarks
 * - The map image is sourced from the `ImageDirectory["map"]`.
 * - The "Get Directions" button opens Google Maps in a new tab with the office location pre-filled.
 */
const MapComponent = () => {
  return (
    <div className="Map-Container">
      <img
        loading="eager"
        fetchPriority="high"
        className="Map-Container"
        src={ImageDirectory["map"]}
        alt="A map of Basingstoke, with a pin marking the location of the Rosemount Financial Solutions IFA office."
      />
      <div className="Address-Container-Content">
        <div className="Address-Container">
          <div className="Content-Large">
            Address: Rosemount House, 2 – 4 Chequers Road, Basingstoke, RG21 7PU
          </div>
          <div className="Content-Large">Working Hours:</div>
          <div className="Content-Large">8:30 - 5:00 Mon to Fri</div>
          <div className="Address-Contanier-Content">
            <ButtonGreen
              buttonText="Get Directions"
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place/Chequers+Rd,+Basingstoke+RG21+7PU/@51.2642792,-1.0857268,17z/data=!3m1!4b1!4m6!3m5!1s0x487421823c4ad3d5:0xaa143b27ef432655!8m2!3d51.2643673!4d-1.0832537!16s%2Fg%2F1tfkvs6w?entry=ttu&g_ep=EgoyMDI0MTIwOC4wIKXMDSoASAFQAw%3D%3D",
                  "_blank"
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapComponent;
